var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.529 8.60421C7.53771 8.27326 7.61201 7.94732 7.7476 7.64529C7.88319 7.34326 8.07738 7.07115 8.3189 6.84471C8.56043 6.61828 8.84449 6.44203 9.15463 6.32618C9.46477 6.21034 9.79481 6.15719 10.1256 6.16983C10.4565 6.18247 10.7815 6.26064 11.0819 6.39981C11.3823 6.53898 11.6521 6.73638 11.8756 6.98058C12.0992 7.22478 12.272 7.51092 12.3842 7.82241C12.4963 8.1339 12.5456 8.46456 12.529 8.79521C12.5243 9.12014 12.4547 9.44085 12.3244 9.73853C12.194 10.0362 12.0055 10.3048 11.77 10.5287C11.5344 10.7525 11.2565 10.9271 10.9525 11.042C10.6486 11.157 10.3247 11.2101 10 11.1982V12.6162M9.99 15.6242H10M19 10.6162C19 11.7981 18.7672 12.9684 18.3149 14.0604C17.8626 15.1523 17.1997 16.1444 16.364 16.9802C15.5282 17.8159 14.5361 18.4788 13.4442 18.9311C12.3522 19.3834 11.1819 19.6162 10 19.6162C8.8181 19.6162 7.64778 19.3834 6.55585 18.9311C5.46392 18.4788 4.47177 17.8159 3.63604 16.9802C2.80031 16.1444 2.13738 15.1523 1.68508 14.0604C1.23279 12.9684 1 11.7981 1 10.6162C1 8.22926 1.94821 5.94008 3.63604 4.25225C5.32387 2.56442 7.61305 1.61621 10 1.61621C12.3869 1.61621 14.6761 2.56442 16.364 4.25225C18.0518 5.94008 19 8.22926 19 10.6162Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.76b2871426aab33509fe2bd232345f26.svg";
export { ForwardRef as ReactComponent };